// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__25vfG","hasCaption":"styles_hasCaption__yUYeb","figure":"styles_figure__KQ6UZ","image":"styles_image__Q9pFp","caption":"styles_caption__k16_l"};